import { render, staticRenderFns } from "./VaimoProductVariant.vue?vue&type=template&id=51b697f6&"
import script from "./VaimoProductVariant.vue?vue&type=script&lang=ts&"
export * from "./VaimoProductVariant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports